import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import DropZone from 'react-dropzone'
import { connect } from 'react-redux'
import { animateScroll } from 'react-scroll'

import {
  buyHelper,
  phaseChange,
  postTransazioniAdd,
  postTransazioniAddCallback,
  reroute,
  storeDumpItForce,
  transazioniUpdate,
} from '../../../actions/Buy'
import {
  distintaFileUploadDropped,
  postBonificoDistintaFileUpload,
} from '../../../actions/buy/Documenti'
import { getTransazioniIban } from '../../../actions/buy/Transazioni'
import verify from '../../../modules/verify'
import fbPixel, { FB_EVENTS } from '../../../utils/fbpixel'
import triggerDataLayerEvent, { GA_EVENTS } from '../../triggerDataLayerEvent'
import BuyHelpBonifico from '../dumb/BuyHelpBonifico'

class Bonifico extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.state.toTop = false
    this.state.bonifico_cro_trn_error = ''
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleHelper = this.handleHelper.bind(this)
    this.onOpenClick = this.onOpenClick.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.purchaseComplete = this.purchaseComplete.bind(this)
    this.handleUpload = this.handleUpload.bind(this)
    this.purchaseComplete = this.purchaseComplete.bind(this)
    this.handleSkip = this.handleSkip.bind(this)
  }

  componentWillMount() {
    if (
      !('token' in this.props.customer) ||
      this.props.customer.token === null ||
      this.props.customer.token.length === 0
    ) {
      this.props.reroute('/register')
    }
  }

  componentDidMount() {
    this.props.phaseChange({ phase: 40 })
    if (!this.state.toTop) {
      animateScroll.scrollToTop()
      this.setState({ toTop: true })
    }
    this.props.storeDumpItForce()
    this.props.getTransazioniIban()
  }

  shouldComponentUpdate(nextProps, nextState) {
    // eslint-disable-next-line
    for (const key in nextState) {
      if (nextState[key] !== this.state[key]) {
        return true
      }
    }
    // eslint-disable-next-line
    for (const key in nextProps) {
      if (key === 'transazioni') {
        continue
      } else if (nextProps[key] !== this.props[key]) {
        return true
      }
    }
    return false
  }

  validate(label, value, requireAttention = false) {
    const v = verify(label, value)
    const new_state = {}
    if (v.is_required || !v.is_valid) {
      new_state[`${label}_error`] = v.is_required ? ' is-required' : ' is-error'
    } else {
      new_state[`${label}_error`] = ' is-ok'
    }
    this.setState(new_state, () => {
      if (
        requireAttention &&
        document.querySelectorAll('.is-error, .is-required').length > 0
      ) {
        animateScroll.scrollTo(
          document.querySelectorAll('.is-error, .is-required')[0].offsetTop -
            95,
          {
            smooth: true,
            dynamic: true,
          }
        )
      }
    })

    return v
  }

  handleInput(label) {
    const t = this
    return function (event) {
      const validate_label_prefix = 'bonifico_'
      const v = t.validate(validate_label_prefix + label, event.target.value)

      const updateHandler = t.props.transazioniUpdate
      updateHandler({
        [label]: v.value,
      })
    }
  }

  validation() {
    const t = this
    const validation_map = {
      bonifico_cro_trn: t.props.transazioni.cro_trn || '',
    }

    const validation_results = Object.keys(validation_map).map(
      key => t.validate(key, validation_map[key]).is_valid
    )

    return (
      validation_results.length > 0 && validation_results.indexOf(false) === -1
    )
  }

  handleSubmit(event) {
    const t = this
    if (!this.props.fetching) {
      if (this.props.distintaFileUpload.dropzone.length > 0) {
        /**
         * BRUM-5269
         * non serve chiamare transazioni per aggiungere il CRO/TRN
         * in caso di upload della distinta
         */
        t.purchaseComplete()
      } else if (t.validation()) {
        t.props
          .postTransazioniAdd({
            method: 'POST',
            uri: `${window.brumbrum.url_api}/transazioni/t/v2/pagamenti`,
            body: JSON.stringify({
              chiave_pagamento: t.props.transazioni.cro_trn,
              id_ordine: t.props.ordine.id_ordine,
            }),
            token: t.props.customer.token,
            callback: t.props.postTransazioniAddCallback,
          })
          .then(t.purchaseComplete)
          .catch(() => null)
      }
      event.preventDefault()
      event.stopPropagation()
    }
  }

  purchaseComplete() {
    fbPixel(FB_EVENTS.Purchase, this.props.product)
    triggerDataLayerEvent(GA_EVENTS.Purchase_bonifico)
    this.props.phaseChange({
      last: this.props.ui.last > 40 ? this.props.ui.last : 40,
    })
    this.props.reroute('/bonifico-ready-for-docs', true)
  }

  handleHelper() {
    this.props.buyHelper()
  }

  bancaBeneficiaria() {
    return `${this.props.transazioni.conti.banca}, filiale di ${this.props.transazioni.conti.filiale}`
  }

  iban() {
    return this.props.transazioni.conti.iban
  }

  onOpenClick(event) {
    event.stopPropagation()
    event.preventDefault()
    this.dropzone.open()
  }

  onDrop(acceptedFiles) {
    this.props.distintaFileUploadDropped({ dropzone: acceptedFiles })
    this.handleUpload(acceptedFiles)
  }

  handleUpload(acceptedFiles) {
    // BRUM-5806 reroute senza parametri fa solo il check disponibilita
    this.props.reroute().then(() => {
      this.props
        .postBonificoDistintaFileUpload({
          dropzone: acceptedFiles,
          token: this.props.customer.token,
          id_ordine: this.props.ordine.id_ordine,
        })
        .then(this.purchaseComplete)
    })
  }

  handleSkip() {
    this.props.phaseChange({
      last: this.props.ui.last > 40 ? this.props.ui.last : 40,
    })
    this.props.reroute('/bonifico-ready-for-docs', true)
  }

  render() {
    numeral.language('it')
    const { customer } = this.props
    const { ordine } = this.props
    const { product } = this.props
    const { ui } = this.props

    return (
      <div>
        <div className="process__header hide-print">
          <h1 className="process__title hide-print">
            Completa l'acquisto della tua {product.marca} {product.modello}
          </h1>
          <p className="process__intro hide-print">
            Conferma l'avvenuto pagamento e preparati a partire con la tua nuova
            auto usata!
          </p>
        </div>
        <div className={'messages transparent left-sm no-padding'}>
          <div className={'container'}>
            Ti abbiamo inviato via mail, la proposta contrattuale. Dalla stessa
            mail potrai tornare a questa pagina per comunicarci l'avvenuto
            bonifico
          </div>
        </div>
        <div className="user-informations">
          <div className="container--small">
            <BuyHelpBonifico
              helper={this.handleHelper}
              show={this.props.help}
            />

            {ui.distintaUploadStatus || ui.croStatus ? (
              <div className="sepa_payment">
                <ul className="data-form x-small">
                  <li className="wide">
                    <div className="documents__upload__other">
                      <span className="only-desktop">
                        <span>Hai gia' caricato la tua distinta!</span>
                      </span>
                    </div>
                  </li>
                  <li className="wide">
                    <a
                      className="btn btn-secondary js-change-url-2"
                      href="#"
                      onClick={this.handleSkip}
                    >
                      <span>Prosegui</span>
                    </a>
                  </li>
                </ul>
              </div>
            ) : (
              <form
                className="form-documents-upload"
                onSubmit={e => {
                  e.preventDefault()
                }}
              >
                <div className="sepa_payment">
                  <div className={'info-wrapper'}>
                    <h5 className={'section-title --reduced secondary'}>
                      Coordinate bonifico
                    </h5>
                    <div className={'bank_details'}>
                      <div className="code">
                        {ordine.acconti ? (
                          <span>
                            Totale ordine:
                            <span>
                              {numeral(ordine.totale).format('$ 0,0.00')}
                            </span>
                            <br />
                            Acconto pre-autorizzato:
                            <span>
                              {numeral(ordine.acconti).format('$ 0,0.00')}
                            </span>
                          </span>
                        ) : null}

                        <br />
                        <span>
                          <h3
                            style={{
                              marginBottom: '10px',
                              fontWeight: 800,
                              display: 'inline-block',
                            }}
                          >
                            Totale {ordine.acconti ? 'dovuto' : null}
                          </h3>
                          <span className="totale_bonifico">
                            {numeral(ordine.totale - ordine.acconti).format(
                              '$ 0,0.00'
                            )}
                          </span>
                        </span>
                      </div>

                      <div className="iban">
                        <p>
                          <span>Intestato a</span>
                          <span className={'right'}>brumbrum S.p.A.</span>
                        </p>
                        <p>
                          <span>IBAN</span>
                          <span className={'right'}>{this.iban()}</span>
                        </p>
                        <p>
                          <span>Causale</span>
                          <span className={'right'} data-hj-suppress>
                            Ordine {ordine.id_ordine} - {customer.nome}{' '}
                            {customer.cognome}
                          </span>
                        </p>
                        <p>
                          <small>
                            <strong>
                              Banca beneficiaria: {this.bancaBeneficiaria()}
                            </strong>
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* FIXME: BRUM_10598
                <ul className="data-form x-small"> */}
                  {/*  <li className="wide form-title no-margin"> */}
                  {/*    <h5 className={"section-title --reduced"}> */}
                  {/*      Hai già effettuato il bonifico? */}
                  {/*    </h5> */}
                  {/*  </li> */}

                  {/*  <BuyRadioInput */}
                  {/*    label={"has_bonifico_sent"} */}
                  {/*    defaultValue={!this.state.showSendEmailForm} */}
                  {/*    values={[ */}
                  {/*      { label: "No", value: false }, */}
                  {/*      { label: "Si", value: true }, */}
                  {/*    ]} */}
                  {/*    update={(event) => { */}
                  {/*      this.setState({ showSendEmailForm: event.target.value !== "true" }); */}
                  {/*    }} */}
                  {/*  /> */}

                  {/*  {!!this.state.showSendEmailForm && */}
                  {/*  <li className="wide"> */}
                  {/*    <p> */}
                  {/*      Per poter riprendere in un altro momento la compilazione del form, ti chiediamo di <b>Confermare */}
                  {/*      il tuo indirizzo di posta</b> tramite l'email di verifica che ti abbiamo inviato. */}
                  {/*    </p> */}
                  {/*    <p> */}
                  {/*      Una volta confermato l'indirizzo, riceverai una mail che ti permette di tornare a questo step ed */}
                  {/*      inserire il codice CRO (o TRN) o la distinta del bonifico */}
                  {/*    </p> */}
                  {/*    <p> */}
                  {/*      Se non hai ricevuto l'email hai la possibilità di reinviarla tramite il campo qui sotto */}
                  {/*    </p> */}
                  {/*  </li> */}
                  {/*  } */}

                  {/*  {!!this.state.showSendEmailForm && ( */}
                  {/*    <li className={`wide ${this.state.bonifico_email_error}`}> */}
                  {/*      <BuyTextInput */}
                  {/*        type={"email"} */}
                  {/*        placeholder={"es: mario.rossi@gmail.com"} */}
                  {/*        label={"Email"} */}
                  {/*        classes="form-input big uppercase wide" */}
                  {/*        update={event => { */}
                  {/*          const value = event.target.value; */}
                  {/*          this.setState({ sendEmailFormValue: value }, () => { */}
                  {/*            this.validate("bonifico_email", value); */}
                  {/*          }); */}
                  {/*        }} */}
                  {/*      /> */}
                  {/*    </li> */}
                  {/*  )} */}

                  {/*  {!!this.state.showSendEmailForm && ( */}
                  {/*    <li className="wide"> */}
                  {/*      <a */}
                  {/*        onClick={() => { */}
                  {/*          console.log("Iban email send"); */}
                  {/*        }} */}
                  {/*        href="#" */}
                  {/*        className={ */}
                  {/*          "btn btn-primary js-change-url-2" +*/}
                  {/*          (this.props.fetching || !this.state.sendEmailFormValue || (!!this.state.bonifico_email_error && this.state.bonifico_email_error !== "") ? " btn-disabled" : "") */}
                  {/*        } */}
                  {/*      > */}
                  {/*        <span> */}
                  {/*          Invia email per verifica */}
                  {/*        </span> */}
                  {/*      </a> */}
                  {/*    </li> */}
                  {/*  )} */}

                  {/* </ul> */}

                  {/* FIXME: BRUM_10598
                {!this.state.showSendEmailForm && */}
                  <ul className="data-form x-small">
                    <li className={`${this.state.bonifico_cro_trn_error} wide`}>
                      <input
                        className="form-input big"
                        data-hj-suppress
                        defaultValue={this.props.transazioni.cro_trn}
                        onBlur={this.handleInput('cro_trn')}
                        type="text"
                      />
                      <label className="label">Codice CRO (o TRN)</label>
                      <div className="help-label left">
                        <span className="help-tip">
                          Conferma il pagamento digitando il CRO (o TRN) emesso
                          dalla tua Banca
                        </span>
                      </div>
                      <div className="help-label right">
                        <span className="help-tip">
                          Il nostro Servizio Clienti
                          <br />è a tua disposizione!
                        </span>
                      </div>
                    </li>
                    <li className="wide">
                      <a
                        className={`btn btn-primary js-change-url-2${
                          this.props.fetching ? ' btn-disabled' : ''
                        }`}
                        href="#"
                        onClick={this.handleSubmit}
                      >
                        <span>Conferma il CRO (o TRN)</span>
                      </a>
                    </li>
                    <li className="wide">
                      <div className="documents__upload__other">
                        <span
                          className={'only-desktop'}
                          style={{ marginBottom: '0px', fontStyle: 'italic' }}
                        >
                          <span>Oppure</span>
                        </span>
                      </div>
                    </li>
                    <li className="wide">
                      <a
                        className={`btn btn-secondary js-change-url-2${
                          this.props.fetching ? ' btn-disabled' : ''
                        }`}
                        href="#"
                        onClick={this.onOpenClick}
                      >
                        <span>Carica la distinta</span>
                      </a>
                    </li>
                    <div className="help-label left only-desktop">
                      <span className="help-tip">Consulta la guida!</span>
                    </div>
                  </ul>
                  {/* FIXME: BRUM_10598
                } */}
                </div>
              </form>
            )}
          </div>
        </div>
        <div style={{ display: 'none' }}>
          <DropZone
            accept="application/pdf,image/jpg,image/jpeg,image/png"
            activeClassName="drag_accept"
            className="drag_drop"
            onDrop={this.onDrop}
            ref={node => {
              this.dropzone = node
            }}
            rejectClassName="drag_reject"
          >
            {({ getRootProps, getInputProps }) => (
              <div {...getRootProps()} className="drag_drop__content">
                <input {...getInputProps()} data-cy="wiretransfer-file" />
                <i className="icon-upload"></i>
                <h2>Trascina qui i tuoi documenti</h2>
                <span style={{ fontSize: '12px', color: '#6B6B6B' }}>
                  (formati consentiti .jpg, .jpeg, .png, .pdf - max 50MB)
                </span>
              </div>
            )}
          </DropZone>
        </div>
      </div>
    )
  }
}

Bonifico.propTypes = {
  customer: PropTypes.object,
  distintaFileUpload: PropTypes.object,
  reroute: PropTypes.func,
  postBonificoDistintaFileUpload: PropTypes.func,
  distintaFileUploadDropped: PropTypes.func,
  phaseChange: PropTypes.func,
  storeDumpItForce: PropTypes.func,
  fetching: PropTypes.bool,
  ordine: PropTypes.object,
  ui: PropTypes.object,
}

const mapStateToProps = state => ({
  customer: state.customer,
  ordine: state.ordine,
  product: state.product,
  transazioni: state.transazioni,
  fetching: state.ui.fetching,
  ui: state.ui,
  help: state.ui.buyHelper,
  distintaFileUpload: state.distintaFileUpload,
})

const mapDispatchToProps = dispatch => ({
  phaseChange: payload => dispatch(phaseChange(payload)),
  postTransazioniAdd: payload => dispatch(postTransazioniAdd(payload)),
  postTransazioniAddCallback: payload =>
    dispatch(postTransazioniAddCallback(payload)),
  distintaFileUploadDropped: payload =>
    dispatch(distintaFileUploadDropped(payload)),
  transazioniUpdate: payload => dispatch(transazioniUpdate(payload)),
  storeDumpItForce: payload => dispatch(storeDumpItForce(payload)),
  reroute: payload => dispatch(reroute(payload)),
  buyHelper: payload => dispatch(buyHelper(payload)),
  postBonificoDistintaFileUpload: payload =>
    dispatch(postBonificoDistintaFileUpload(payload)),
  getTransazioniIban: () => dispatch(getTransazioniIban),
})

export default connect(mapStateToProps, mapDispatchToProps)(Bonifico)
